/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateProxyFromUrlRequest
 */
export interface CreateProxyFromUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateProxyFromUrlRequest
     */
    proxyUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProxyFromUrlRequest
     */
    proxyName?: string | null;
}

/**
 * Check if a given object implements the CreateProxyFromUrlRequest interface.
 */
export function instanceOfCreateProxyFromUrlRequest(value: object): value is CreateProxyFromUrlRequest {
    if (!('proxyUrl' in value) || value['proxyUrl'] === undefined) return false;
    return true;
}

export function CreateProxyFromUrlRequestFromJSON(json: any): CreateProxyFromUrlRequest {
    return CreateProxyFromUrlRequestFromJSONTyped(json, false);
}

export function CreateProxyFromUrlRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProxyFromUrlRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'proxyUrl': json['proxy_url'],
        'proxyName': json['proxy_name'] == null ? undefined : json['proxy_name'],
    };
}

export function CreateProxyFromUrlRequestToJSON(json: any): CreateProxyFromUrlRequest {
    return CreateProxyFromUrlRequestToJSONTyped(json, false);
}

export function CreateProxyFromUrlRequestToJSONTyped(value?: CreateProxyFromUrlRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proxy_url': value['proxyUrl'],
        'proxy_name': value['proxyName'],
    };
}

